module.exports = __webpack_public_path__ + "img/enable_push_notification.ccf3779a.png";